
export default function Modal({onClose, imageUrl}) {
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center transition duration-300 z-50">
        <button className="absolute top-0 right-8 text-white text-8xl drop-shadow-lg" onClick={onClose}>&times;</button>
        <img src={`${imageUrl}`} alt="Modal" className="h-[90vh] selection:bg-transparent" />
    </div>
  )
}
